import i18n from 'shared/lib/i18n';

import InactivityModalComponent from './InactivityModalComponent';

import { SET_MODAL_TYPE } from '../../actionConstants';
import { logout } from '../Auth/actionCreators';

import { saveLastActivityTime } from '../../utils';

import { INACTIVITY_COUNT_DOWN_TIME } from '../../staticData';
import { WITH_COUNTDOWN } from '../Modal/modalTypes';

export const onInactivityTimeOut = (dispatch) => {
  const modalProps = {
    title: i18n.t('title.sessionTimeOut'),
    countDownTime: INACTIVITY_COUNT_DOWN_TIME / 1000,
    onConfirm: () => {
      saveLastActivityTime();
      dispatch({ type: SET_MODAL_TYPE, modalType: null });
    },
    onCancel: () => logout(dispatch),
    callbackAfterTimeOut: () => logout(dispatch),
    hideCloseButton: true,
    render: (state, props) => (
      <InactivityModalComponent state={state} props={props} />
    ),
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: WITH_COUNTDOWN,
    modalProps,
  });
};
